module.exports = __webpack_public_path__ + "img/gear-D_170x170.13aa3a3e.png";